<template>
  <div class="flex flex-col p-4">
    <div class="my-3">
      {{question.question_know}}
    </div>
    <check-button radio="yes" v-model="result">{{$t('yes')}}</check-button>
    <check-button radio="no" v-model="result">{{$t('no')}}</check-button>

    <button class="btn btn-1 my-2" :disabled="!result" @click="send()">{{$t('continue')}}</button>

  </div>
</template>

<script>
import CheckButton from '@/components/CheckButton'

export default {
  data() {
    const a = this.answer || {}
    return {
      result: a.result
    }
  },

  components: {
    CheckButton: CheckButton,
  },

  props: {
    question: Object,
    answer: Object,
  },
  
  methods: {
    send() {
      const answer = Object.create(null)
      answer['result'] = this.result

      this.$emit('input', answer)
    }
  }
}
</script>

<style>

</style>